import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  VideoGroupsActions,
  stateStatusType,
  FetchVideoGroupsRequestAction,
  FetchVideoGroupsSuccessAction,
  FetchVideoGroupsFailureAction,
  CreateVideoGroupSuccessAction,
  UpdateVideoGroupSuccessAction,
  DeleteVideoGroupSuccessAction,
  DeleteVideoGroupFailureAction,
  CreateVideoGroupFailAction,
  UpdateVideoGroupFailAction,
} from "./actionType";
import { VideoGroupState, initialState } from "./state";

//FetchVideoGroupsRequest
const FetchVideoGroupsRequest = (
  state: VideoGroupState,
  action: FetchVideoGroupsRequestAction
) => {
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};

const FetchVideoGroupsSuccess = (
  state: VideoGroupState,
  action: FetchVideoGroupsSuccessAction
) => {
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      groups: action.payload,
      delete: null,
    },
  });
};

const FetchVideoGroupsFail = (
  state: VideoGroupState,
  action: FetchVideoGroupsFailureAction
) => {
  return updateObject(state, {
    videoGroupState: {
      ...state.videoGroupsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      groups: null,
      delete: null,
    },
  });
};

const CreateVideoGroupSuccess = (
  state: VideoGroupState,
  action: CreateVideoGroupSuccessAction
) => {
  const newVideoGroups = state.videoGroupsState.groups ?? [];
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      groups: [...newVideoGroups, action.payload],
      delete: null,
      error: null,
    },
  });
};
const CreateVideoGroupFail = (
  state: VideoGroupState,
  action: CreateVideoGroupFailAction
) => {
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      error: action.payload,
      delete: null,
      status: stateStatusType.FAILED,
    },
  });
};
const UpdateVideoGroupSuccess = (
  state: VideoGroupState,
  action: UpdateVideoGroupSuccessAction
) => {
  var newVideoGroups = state.videoGroupsState.groups?.map((item) =>
    item.id === action.payload.id ? action.payload : item
  ) ?? [action.payload];
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      groups: [...newVideoGroups],
      delete: null,
    },
  });
};

const UpdateVideoGroupFail = (
  state: VideoGroupState,
  action: UpdateVideoGroupFailAction
) => {
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      delete: null,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const DeleteVideoGroupSuccess = (
  state: VideoGroupState,
  action: DeleteVideoGroupSuccessAction
) => {
  var newVideoGroups =
    state.videoGroupsState.groups?.filter(
      (item) => item.id !== action.payload
    ) ?? [];
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      groups: [...newVideoGroups],
      delete: null,
    },
  });
};
const DeleteVideoGroupFail = (
  state: VideoGroupState,
  action: DeleteVideoGroupFailureAction
) => {
  return updateObject(state, {
    videoGroupsState: {
      ...state.videoGroupsState,
      isLoading: false,
      delete: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const videoGroupsReducer = (
  state = initialState,
  action: VideoGroupsActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_GROUPS_REQUEST:
      return FetchVideoGroupsRequest(state, action);
    case actionTypes.FETCH_VIDEO_GROUPS_SUCCESS:
      return FetchVideoGroupsSuccess(state, action);
    case actionTypes.FETCH_VIDEO_GROUPS_FAIL:
      return FetchVideoGroupsFail(state, action);
    case actionTypes.CREATE_VIDEO_GROUP_SUCCESS:
      return CreateVideoGroupSuccess(state, action);
    case actionTypes.CREATE_VIDEO_GROUP_FAIL:
      return CreateVideoGroupFail(state, action);
    case actionTypes.UPDATE_VIDEO_GROUP_SUCCESS:
      return UpdateVideoGroupSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_GROUP_FAIL:
      return UpdateVideoGroupFail(state, action);
    case actionTypes.DELETE_VIDEO_GROUP_SUCCESS:
      return DeleteVideoGroupSuccess(state, action);
    case actionTypes.DELETE_VIDEO_GROUP_FAILED:
      return DeleteVideoGroupFail(state, action);
    default:
      return state;
  }
};

export default videoGroupsReducer;
